import React, { createRef, useState, useEffect, useContext, useRef } from "react";
import axios from 'axios';

import Dropzone from "react-dropzone";
import LargeImageUpload from "../../images/drag_drop_large_image.svg";
import ImageUpload from "../../images/drag_drop_image.svg";
import VideoUploadSelectionImage from "../../images/Drag_Video.svg";
import VideoUploadSelectionLargeImage from "../../images/Drag_large_Video.svg";
import Structure from "../../images/default_structure_new_icon.svg";
import ImageActive from "../../images/active_image_new_icon.svg";
import VideoActive from "../../images/Video_Active.svg";
import InActiveForm from "../../images/default_forms_new_icon.svg";
import InActiveExtraIcon from "../../images/default_devider_new_icon.svg";
import LeftIcon from "../../images/left_arrow_image_icon.svg";
import deleteIcon from "../../images/DeleteNewIcon.svg";
import "react-toastify/dist/ReactToastify.css";

import {
  deleteSharedFiles,
  uploadVideoDragAndDrop,
  updateSlidesWithPosterUpload,
  updateSlidesWithPosterDelete,
} from "../../services/apis";
import { Tabs, Tab, Spinner, Button } from "react-bootstrap";
import InfoIcon from '../../images/InfoIconGray.svg';
import { showErrorToast, showSuccessToast } from "../toastComponent/ToastComponent";
import CustomPopupModal from "../CustomPopupModal/CustomPopupModal";
import VideoUploadProgressCard from "./VideoUploadProgressCard";
import PreviewVideoTab from "./PreviewVideoTab";
import DeleteVideoModal from "./DeleteVideoModal";

import "./VideoMediaTab.scss";

// import { useTranslation } from "react-i18next";

function VideoMediaTab({
  localVideoList,
  setLocalVideoList,
  localPosterList,
  setLocalPosterList,
  ...props
}) {
  const [videoFile, setVideoFile] = useState(null);
  const [posterFile, setPosterFile] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadPopup, setUploadPopup] = useState(false);
  const [uploadAPIState, setUploadAPIState] = useState({
    status: 'idle',     // 'idle' | 'loading' | 'success' | 'fail'
    message: '',        // Any feedback message
  });
  const { deckData } = props;
  const [duration, setDuration] = useState(null);
  const cancelSourceRef = useRef(null);

  const dropzoneRef = createRef();
  const posterDropzoneRef = createRef();
  const videoRef = useRef(null);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isDeleteVideoModalOpen, setIsDeleteVideoModalOpen] = useState(false);
  const [deleteVideoData, setDeleteVideoData] = useState(null);
  const [deletePosterData, setDeletePosterData] = useState(null);
  const [viewVideo, setViewVideo] = useState(null);
  const [viewPoster, setViewPoster] = useState(null);
  const [videoType, setVideoType] = useState();
  const [uploadType, setUploadType] = useState("Video");

  useEffect(() => {
    if (!uploadPopup) {
      resetPopup();
    }
  }, [uploadPopup]);

  const resetPopup = () => {
    setUploadProgress(0);
    setUploadAPIState({ status: 'idle', message: '' });
    setVideoFile(null);
    setPosterFile(null);
    setUploadType("Video");
  };

  useEffect(() => {
  const preventDefault = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  window.addEventListener('dragover', preventDefault);
  window.addEventListener('drop', preventDefault);

  return () => {
    window.removeEventListener('dragover', preventDefault);
    window.removeEventListener('drop', preventDefault);
  };
}, []);

  const sendVideo = (event, type, loadVideo) => {
    if(type === 'click') {
      const selected = props?.editor?.getSelected();
      const videoUrl = loadVideo.link;
      selected?.set({ src: videoUrl });
      // Wait for the video to load before getting its actual dimensions
      setTimeout(() => {
          const el = selected?.view?.el?.querySelector('video');
        if (el) {
            el.addEventListener('loadedmetadata', () => {
                const { videoWidth, videoHeight } = el;
            // Calculate height based on aspect ratio
            const targetWidth = 300;
            const aspectRatio = videoHeight / videoWidth;
            const targetHeight = Math.round(targetWidth * aspectRatio);

            // Apply width, calculated height, and background color
            selected?.addStyle({
              width: `${targetWidth}px`,
              height: `${targetHeight}px`,
              'background-color': 'black',
              'object-fit': 'cover',
            });
            if (localPosterList.length) {
                const posterUrl = localPosterList[0]?.link;
                selected?.set({ poster: posterUrl });
                selected?.setAttributes({ poster: posterUrl });
              }
          }, { once: true }); // Only run once
        }
      }, 0);
    } else if(type === "drag") {
      event.dataTransfer.setData('application/json', JSON.stringify(loadVideo));
      event.dataTransfer.effectAllowed = 'copy';
      event.dataTransfer.setDragImage(event.nativeEvent.srcElement, 0, 0);
    }
  };

//   const sendVideo = (loadVideo) => {
//   const selected = props?.editor?.getSelected();
//   console.log(loadVideo, 'llo');
//   if (!selected) return;

//   const videoUrl = loadVideo.link;

//   // Update video source
//   selected.set({ src: videoUrl });

//   // Access the actual video element inside the component view
//   const el = selected?.view?.el?.querySelector('video');

//   if (el) {
//     // Use loadedmetadata event to get video dimensions once metadata is loaded
//     el.addEventListener('loadedmetadata', () => {
//       const { videoWidth, videoHeight } = el;
//       const targetWidth = 300;
//       const aspectRatio = videoHeight / videoWidth;
//       const targetHeight = Math.round(targetWidth * aspectRatio);

//       // Apply styles for size and appearance
//       selected.addStyle({
//         width: `${targetWidth}px`,
//         height: `${targetHeight}px`,
//         'background-color': 'black',
//         'object-fit': 'cover',
//       });

//       // Optionally set poster if available
//       if (localPosterList.length > 0) {
//         const posterUrl = localPosterList[0]?.link;
//         selected.set({ poster: posterUrl });
//         selected.setAttributes({ poster: posterUrl });
//       }
//     }, { once: true }); // Only fire once
//   }
// };

  const HideStructureBlock = () => {
    console.log('opp')
    const hideStructureBlockgjs = document.querySelector(".gjs-block-categories .gjs-blocks-c");
    const showStructure = document.querySelector(".gjs-blocks-no-cat .gjs-blocks-c").firstChild;
    showStructure.getElementsByClassName("gjs-block__media")[0].firstChild.src = Structure;
    showStructure.classList.remove("active-block");
    hideStructureBlockgjs.classList.add("d-none");
    const hideForms = document.querySelector(".gjs-block-categories").lastChild;
    hideForms.classList.add("d-none");
    const showDefaultForm = document.querySelector(".gjs-blocks-no-cat .gjs-blocks-c").childNodes[7];
    // if (showDefaultForm) {
    //   showDefaultForm.style.background = "white";
    //   showDefaultForm.getElementsByClassName("gjs-block__media")[0].firstChild.src = InActiveForm;
    //   showDefaultForm.classList.remove("active-block");
    // }
    const inActiveExtra = document?.querySelector(
      ".gjs-blocks-no-cat .gjs-blocks-c"
    )?.childNodes[8];
    // if (inActiveExtra) {
    //   inActiveExtra.getElementsByClassName(
    //     "gjs-block__media"
    //   )[0].lastChild.src = InActiveExtraIcon;
    //   inActiveExtra.classList.remove("active-block");
    // }
  }

  const highlightImageIcon = () => {
    console.log('opp8888')

    const hideStructureBlockgjs = document.querySelector(".gjs-block-categories .gjs-blocks-c");
    const ImageBlock = document.querySelector(".gjs-blocks-no-cat .gjs-blocks-c").children[3];
    ImageBlock.getElementsByClassName("gjs-block__media")[0].firstChild.src = VideoActive;
    ImageBlock.classList.add("active-block");
    // ImageBlock.getElementsByClassName("gjs-block__media")[0].firstChild.classList.add("img-block");
  }


  useEffect(() => {
    props.setState(true);
    HideStructureBlock();
    highlightImageIcon();
    // const sourceElement = videoRef?.current?.querySelector('source');
    // const type = sourceElement?.type;
    // console.log(type, 'trtrtrt');
    // setVideoType(type);
  }, []);

  const fileValidation = (uploadFile) => {
    var allowedExtensions = [
      "video/mp4",          // .mp4
      "video/quicktime",    // .mov
      // "video/x-msvideo",    // .avi
      // "video/x-ms-wmv"      // .wmv
    ];
    if (!allowedExtensions.includes(uploadFile.type)) {
      showErrorToast('Unsupported File Type. Kindly use .MP4, .MOV'); // , .AVI, .WMV
      return false;
    }
    return true;
  };

  const imageFileValidation = (uploadFile) => {
    var allowedExtensions = ["image/jpeg", "image/jpg", "image/png"];
    if (!allowedExtensions.includes(uploadFile.type)) {
      showErrorToast('Unsupported File Type. Kindly use .JPG, .JPEG, .PNG');
      return false;
    }
    return true;
  };

  const addPosterWithVideo = (posterUrl) => {
    if (!localVideoList.length) return;

    const videoUrl = localVideoList[0]?.link;
    const editor = props.editor;
    if (!editor) return;

    const allComponents = editor.DomComponents.getComponents();

    const traverseComponents = components => {
      components.forEach(comp => {
        if (comp.is('video')) {
          const src = comp.get('src');
          if (src === videoUrl) {
            comp.set({ poster: posterUrl });
            comp.setAttributes({ poster: posterUrl });
          }
        }
        else if (comp.components && comp.components().length) {
          traverseComponents(comp.components());
        }
      });
    };
    traverseComponents(allComponents);
  };

  const removePosterFromVideo = () => {
    if (!localVideoList.length) return;

    const videoUrl = localVideoList[0]?.link;
    const editor = props.editor;
    if (!editor) return;

    const allComponents = editor.DomComponents.getComponents();

    const traverseComponents = components => {
      components.forEach(comp => {
        if (comp.is('video')) {
          const src = comp.get('src');
          if (src === videoUrl) {
            comp.set({ poster: '' });
            comp.setAttributes({ poster: '' });
            comp.set({ src: '' });
            comp.set({ src: videoUrl });
          }
        }
        else if (comp.components && comp.components().length) {
          traverseComponents(comp.components());
        }
      });
    };
    traverseComponents(allComponents);
  };

  const uploadVideoPoster = (uploadFile, type) => {
    const formData = new FormData();
    switch (type) {
      case 'Video':
        formData.append("videos", uploadFile);
        break;
      case 'Poster':
        formData.append("posters", uploadFile);
        break;
      default:
        return;
    }

    cancelSourceRef.current = axios.CancelToken.source(); // Create cancel token
    uploadVideoDragAndDrop(props.deckData._id, formData,
      (response, err, errorCode) => {
        if (err) {
          let message;
          let uploadAPIStateChange = true;
          switch (err.code) {
            case "ECONNABORTED":
              message = "The upload is taking too long. Please check your internet connection and try again."
              break;

            case "ERR_NETWORK":
              message = "Network error. Please check your internet connection and try again."
              break;

            case "ERR_CANCELED":
              // message = "Upload was cancelled";
              uploadAPIStateChange = false;
              break;

            default:
              message = err?.response?.data?.err?.[0]?.msg || ((typeof (err?.response?.data?.err) === 'string' && (err?.response?.data?.err).trim() !== '') ? (err?.response?.data?.err) : 'Something went wrong during the upload. Please try again.');

          }
          uploadAPIStateChange && setUploadAPIState({
            status: 'fail',
            message,
          });
          type === "Poster" && showErrorToast(message);
        } else {

          showSuccessToast(`${type} uploaded successfully`);
          type === "Video" && setLocalVideoList(response?.data?.response?.allVideos || []);
          if (type === "Poster") {
            setLocalPosterList(response?.data?.response?.allPosters || []);
            const videoUrl = localVideoList[0]?.link;
            const posterUrl = response?.data?.response?.allPosters?.[0]?.link || null;
            let updateSlidesPayload = {
              posterUrl,
              videoUrl,
              deckId: props.deckData._id,
            };
            updateSlidesWithPosterUpload(updateSlidesPayload, (response, err, errorCode) => {
              if (err) {
              } else {
              }
            });
            posterUrl && addPosterWithVideo(posterUrl);
          }

          setUploadAPIState({
            status: 'success',
            message: '',
          });
          setUploadPopup(false);
        }
        type === "Poster" && resetPopup();
      },
      (progress) => {
        setUploadProgress(progress);
        if (progress == 100 && uploadAPIState.status === 'idle') {
          setUploadAPIState({ status: 'loading', message: '' });
        }
      },
      cancelSourceRef.current.token,
    );

  }

  const onDropImage = (accepted, rejected) => {
    //console.log(accepted, 'kkkk', rejected)
    if (localPosterList.length) return; // ignore drops if disabled
    if (accepted.length > 1) {
      showErrorToast('Please select only one video to upload.');
      return;
    }
    if (Object.keys(rejected).length !== 0) {
      let isUnsupportedFile = false;
      for (const rejectedFile of rejected) {
        for (const error of rejectedFile.errors) {
          if (error.code === 'file-invalid-type') {
            isUnsupportedFile = true;
            break;
          }
        }
        if (isUnsupportedFile) break;
      }
      if (isUnsupportedFile) {
        showErrorToast('Unsupported File Type. Kindly use .JPG, .JPEG, .PNG');
      }
      else {
        showErrorToast('The file was rejected during upload. Please check the file and try again.');
      }
      return false;
    } else {
      const maxImageFileSize = 5 * 1024 * 1024; // 5MB in bytes
      const uploadFile = accepted[0];
      if (uploadFile.size > maxImageFileSize) {
        showErrorToast('Poster upload failed, cannot upload image of size more than 5MB.!');
        return;
      }
      if (!imageFileValidation(uploadFile)) return;
      setPosterFile(uploadFile);
      // setUploadPopup(true);
      uploadVideoPoster(uploadFile, 'Poster');
    }
  };

  const onDropVideo = async (accepted, rejected) => {
    // console.log(accepted, 'kkkk', rejected);
    if (localVideoList.length) return; // ignore drops if disabled
    if (accepted.length > 1) {
      showErrorToast('Please select only one video to upload.');
      return;
    }
    if (Object.keys(rejected).length !== 0) {
      let isUnsupportedFile = false;
      for (const rejectedFile of rejected) {
        for (const error of rejectedFile.errors) {
          if (error.code === 'file-invalid-type') {
            isUnsupportedFile = true;
            break;
          }
        }
        if (isUnsupportedFile) break;
      }
      if (isUnsupportedFile) {
        showErrorToast('Unsupported File Type. Kindly use .MP4, .MOV'); // , .AVI, .WMV
      }
      else {
        showErrorToast('The file was rejected during upload. Please check the file and try again.');
      }
      return false;
    } else {
      let validatedData = true;
      const maxVideoFileSize = 20 * 1024 * 1024; // 20MB in bytes

      const uploadFile = accepted[0];
      validatedData = fileValidation(uploadFile);
      if (!validatedData) return;
      if (uploadFile.size > maxVideoFileSize) {
        showErrorToast('Video upload failed, cannot upload video of size more than 20MB.!');
        return;
      }
      setVideoFile(uploadFile);
      setUploadPopup(true);
      uploadVideoPoster(uploadFile, 'Video');
    }
  };

  const handleCancel = () => {
    if (cancelSourceRef.current) {
      cancelSourceRef.current.cancel("User cancelled upload");
    }
  };

  const backButtonHandler = () => {
    props.editor.select(null);
    props.setVideoSelected(false);
    document.querySelector(".custom-video").click();
    props.editor.AssetManager.close();
    props.setState(false);
  }

  const handleLoadedMetadata = (e) => {
    const video = videoRef.current;
    if (video) {
      const minutes = Math.floor(video?.duration / 60);
      const seconds = Math.floor(video?.duration % 60);
      setDuration(`${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`);
    }
  };

  const openPreviewImageTab = (list) => {
    setViewPoster(list);
    setIsViewModalOpen(true);
  }

  const openPreviewVideoTab = (list) => {
    setViewVideo(list);
    setIsViewModalOpen(true);
  }

  const deleteVideo = (video) => {
    setDeleteVideoData(video);
    setIsDeleteVideoModalOpen(true);
  }
  const deletePoster = (poster) => {
    setDeletePosterData(poster);
  }

  const removeVideoSrc = (videoUrl) => {
    const editor = props.editor;
    if (!editor) return;

    const allComponents = editor.DomComponents.getComponents();

    const traverseComponents = components => {
      components.forEach(comp => {
        if (comp.is('video')) {
          const src = comp.get('src');
          if (src === videoUrl) {
            comp.set('src', '');
            comp.set({ poster: '' });
            comp.setAttributes({ poster: '' });
          }
        }
        else if (comp.components && comp.components().length) {
          traverseComponents(comp.components());
        }
      });
    };
    traverseComponents(allComponents);
  };

  const deleteVideoHandler = (type) => {
    if (type === "Yes") {
      const payloadObj = { list: deleteVideoData, deckId: deckData?._id };
      deleteSharedFiles(payloadObj, (response, err, ErrorCode) => {
        if (err) {
          setIsDeleteVideoModalOpen(false);
          // setIsloading(false);
          // toastErrorThrow([], "Delete");
        } else {
          // setIsloading(false);
          if (localPosterList.length) {
            deletePosterHandler("Yes", localPosterList[0]);
          }
          else {
            showSuccessToast("Deleted Successfully");
          }
          setLocalVideoList([]);
          setDeleteVideoData(null);
          removeVideoSrc(deleteVideoData?.link);
          setIsDeleteVideoModalOpen(false);
        }
      });
    } else {
      setIsDeleteVideoModalOpen(false);
    }
  }

  const deletePosterHandler = (type, explicitDeletePosterData) => {
    if (type === "Yes") {
      const payloadObj = { list: deletePosterData || explicitDeletePosterData, deckId: deckData?._id };
      deleteSharedFiles(payloadObj, (response, err, ErrorCode) => {
        if (err) {
          setDeletePosterData(null);
        } else {
          // setIsloading(false);
          removePosterFromVideo();
          setLocalPosterList([]);
          setDeletePosterData(null);
          showSuccessToast("Deleted Successfully");
          const videoUrl = localVideoList[0]?.link;
          let updateSlidesPayload = {
            videoUrl,
            deckId: props.deckData._id,
          };
          updateSlidesWithPosterDelete(updateSlidesPayload, (response, err, errorCode) => {
            if (err) {
            } else {
            }
          });
        }
      });
    }
    else {
      setDeletePosterData(null);
    }
  }

  const getMimeType = (url) => {
    const extension = url?.split('.').pop()?.toLowerCase();
    switch (extension) {
      case 'mp4': return 'video/mp4';
      case 'mov': return 'video/mp4';
      default: return 'video/mp4';
    }
  };

  return (
    <div className="dat-tab">
      <div className="properties-block">
        <div className="image_back_button">
          <div className="image_back_icon d-flex">
            <img src={LeftIcon} alt="" className="image-tab-back-button" onClick={backButtonHandler} />
            <span className="image_back_text">
              <span className="image_back_text_bold">Video </span>
              <span className="image_bcak_text_normal">(Add/Import/Upload)</span>
            </span>
          </div>
        </div>
        <Tabs
          variant="link"
          defaultActiveKey="tab-1"
          className="mb-1 list-inline iamgeTabs imageTabs"
        >
          <Tab
            className="iamgeTabs customScrollBar videoTabContent"
            eventKey="tab-1"
            title={`Local`}
          >
            <div className="local-video-tab">
              <div className="image-local-tab">
                <div className={`dragDrop${localVideoList.length ? " disabled" : ""}`} title={localVideoList.length ? "Disabled" : "Select to browse"}>
                  <Dropzone
                    ref={dropzoneRef}
                    multiple={false}
                    accept={{
                      'video/mp4': ['.mp4'],
                      'video/quicktime': ['.mov'],
                      // 'video/x-msvideo': ['.avi'],         // for .avi
                      // 'video/x-ms-wmv': ['.wmv']           // for .wmv
                    }}
                    onDrop={(accepted, rejected) => onDropVideo(accepted, rejected)}
                    disabled={localVideoList.length ? true : false}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <div {...getRootProps()} className="">
                        <input {...getInputProps()} />
                        <div className="drag-drop-image">
                          <img src={props.expandLeft === 450 ? VideoUploadSelectionLargeImage : VideoUploadSelectionImage} className="img-fluid" />
                        </div>
                      </div>
                    )}
                  </Dropzone>
                  <div className="drag-drop-here">
                    <img src={InfoIcon} alt="InfoIcon" width={8} height={8} />
                    <p>Drag & drop or select to browse (Max 20 MB) | Supported: .MP4, .MOV</p>
                    {/* , .AVI, .WMV. */}
                  </div>
                </div>
              </div>
              {localVideoList?.length > 0 && (
                <>
                  <div className="uploadedVideoScroll customScrollBar" style={{ marginTop: '12px', padding: '0 16px', justifyContent: localVideoList?.length < 1 ? 'center' : '', alignContent: localVideoList?.length < 1 ? 'center' : '' }}>
                    {localVideoList?.map((loadVideo, index) => (
                      <div className="row videoRow">
                        <div className="col-md-12">
                          <div class="thumbnail-video-content-card">
                            <div className="d-flex justify-content-center align-items-center" style={{ position: 'relative' }}>
                              <div className="ratio ratio-16x9">
                                <video 
                                  style={{
                                    display: 'block',
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover', // optional: ensures full coverage
                                    cursor: 'all-scroll'
                                  }}
                                  draggable="true"
                                  onClick={(e) => sendVideo(e, 'click', loadVideo)}
                                  // onDragEnd={(e) => sendVideo(e,'drag', loadVideo)}
                                  onDragStart={(e) => sendVideo(e,'drag', loadVideo)}
                                  ref={videoRef} 
                                  onLoadedMetadata={handleLoadedMetadata}
                                >
                                  <source src={loadVideo?.link} type={getMimeType(loadVideo?.name)} />
                                </video>
                                {/* <video
                                  style={{
                                    display: 'block',
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover', // optional: ensures full coverage
                                    cursor: 'all-scroll'
                                  }}
                                  draggable={true} // usually you don’t want the video itself to be draggable if it's drop target
                                  onDrop={(e) => {
                                    e.preventDefault();
                                    const data = e.dataTransfer.getData('text');
                                    // Use sendVideo with the dropped data
                                    sendVideo({ link: data, name: 'video.mp4' });
                                  }}
                                  onDragOver={(e) => e.preventDefault()} // enable drop
                                  ref={videoRef}
                                  onLoadedMetadata={handleLoadedMetadata}
                                >
                                  <source src={loadVideo?.link} type={getMimeType(loadVideo?.name)} />
                                </video> */}

                              </div>
                              {duration && <p className="video-duration">{duration}</p>}
                            </div>
                            <div className="d-flex align-items-center justify-content-between" style={{ padding: "5px 16px", background: "#F0F5F8", borderBottomLeftRadius: "6px", borderBottomRightRadius: "6px" }}>
                              <button className="view-video" onClick={() => openPreviewVideoTab(loadVideo)}>View</button>
                              <img src={deleteIcon} style={{ cursor: "pointer" }} width={16} height={16} className="delete-video-icon" onClick={() => deleteVideo(loadVideo)} />
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="poster-upload-list-wrapper">
                    <div className="upload-poster-heading">
                      <span className="upload-poster-heading-text-bold">Thumbnail </span>
                      <span className="upload-poster-heading-text-normal">(Add/Import/Upload)</span>
                    </div>
                    <div className="image-local-tab">
                      <div className={`dragDrop${localPosterList.length ? " disabled" : ""}`} title={localPosterList.length ? "Disabled" : "Select to browse"}>
                        <Dropzone
                          ref={posterDropzoneRef}
                          multiple={false}
                          accept={{
                            'image/jpeg': ['.jpeg', '.jpg'],
                            'image/png': ['.png'],
                            // 'image/gif': ['.gif'],
                            // 'image/svg+xml': ['.svg'],
                          }}
                          onDrop={(accepted, rejected) => onDropImage(accepted, rejected)}
                          disabled={localPosterList.length ? true : false}
                        >
                          {({ getRootProps, getInputProps }) => (
                            <div {...getRootProps()} className="">
                              <input {...getInputProps()} />
                              <div className="drag-drop-image">
                                <img src={props.expandLeft === 450 ? LargeImageUpload : ImageUpload} className="img-fluid" />
                              </div>
                            </div>
                          )}
                        </Dropzone>
                        <div className="poster-drop-info">
                          <img src={InfoIcon} alt="InfoIcon" width={8} height={8} />
                          <p>Drag & drop or select to browse <br />(Max 5.0 MB) | Supported: .JPG, .JPEG, .PNG</p>
                          {/* , .AVI, .WMV. */}
                        </div>
                      </div>
                    </div>

                    <div className="uploadedVideoScroll customScrollBar poster-list" style={{ marginTop: '12px', padding: '0 16px', justifyContent: localPosterList?.length < 1 ? 'center' : '', alignContent: localPosterList?.length < 1 ? 'center' : '' }}>
                      {localPosterList?.map((loadPoster, index) => (
                        <div className="row videoRow">
                          <div className="col-md-12">
                            <div class="thumbnail-video-content-card">
                              <div className="d-flex justify-content-center align-items-center">
                                <img className="img-fluid video-poster-image" title="Auto-applied with video (not selectable)" style={{
                                  display: 'block',
                                  maxheight: '200px',
                                  objectFit: 'cover', // optional: ensures full coverage
                                }} src={loadPoster?.link} alt="" />
                              </div>
                              <div className="d-flex align-items-center justify-content-between" style={{ padding: "5px 16px", background: "#F0F5F8", borderBottomLeftRadius: "6px", borderBottomRightRadius: "6px" }}>
                                <button className="view-video" onClick={() => openPreviewImageTab(loadPoster)}>View</button>
                                <img src={deleteIcon} style={{ cursor: "pointer" }} width={16} height={16} className="delete-video-icon" onClick={() => deletePoster(loadPoster)} />
                              </div>

                              {deletePosterData?.name === loadPoster?.name && (
                                <div className="poster-delete-confirmation">
                                  <div className="poster-delete-confirmation-message">
                                    The image to be deleted might have been used in slides.
                                    <br />Are you sure?
                                  </div>
                                  <div className="d-flex justify-content-between">
                                    <button
                                      className="poster-delete-confirm-no btn btn-default"
                                      onClick={() => deletePosterHandler("No")}
                                    >
                                      NO
                                    </button>
                                    <button
                                      className="poster-delete-confirm-yes btn btn-default"
                                      onClick={() => deletePosterHandler("Yes")}
                                    >
                                      YES, DELETE
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              )}
            </div>
            {
              uploadPopup && <CustomPopupModal popupBody={
                <>
                  <div className="video-upload-progress-card-wrapper">
                    <h2 className="unsaved-changes-text">Upload</h2>
                    <VideoUploadProgressCard
                      videoFile={videoFile}
                      posterFile={posterFile}
                      progress={uploadProgress}
                    />
                    {uploadProgress !== undefined && uploadAPIState.status !== 'fail' && (
                      <div className="progress-wrapper">
                        <div className="progress" title={uploadType}>
                          <div
                            className="progress-bar"
                            style={{ width: `${uploadProgress}%` }}
                          ></div>
                        </div>
                        {uploadProgress}%
                      </div>
                    )}
                  </div>
                  <div style={{ marginTop: '1em' }}>
                    {uploadAPIState.status === 'loading' && <div className="d-flex justify-content-center">
                      <Spinner className="custom-inline-spinner" animation="border" role="status" size="sm" />
                    </div>}
                    {/* {uploadAPIState.status === 'success' && (
                      <span style={{ color: 'green' }}>✅ {uploadAPIState.message}</span>
                    )} */}
                    {uploadAPIState.status === 'fail' && (
                      <span style={{ color: 'red' }}>❌ {uploadAPIState.message}</span>
                    )}
                  </div>
                </>
              }
                popupFooterButtonLabel={uploadAPIState.status === 'fail' ? "CLOSE" : "CANCEL"}
                popupFooterButtonClick={() => {
                  if (uploadAPIState.status === 'idle') {
                    handleCancel();
                  }
                  setUploadPopup(false);
                }}
                popupFooterButtonStatus={uploadAPIState.status !== 'loading'}
              />}
          </Tab>

          {/* <Tab
            eventKey="tab-2"
            className="videoTabs customScrollBar"
            title={`PromoMats`}
          >
          </Tab>
          <Tab
            eventKey="tab-3"
            className="videoTabs customScrollBar"
            title={`Links`}
          // title={`Links (${imageURL.length})`}
          >
          </Tab> */}

        </Tabs>
      </div>
      {isViewModalOpen && (<PreviewVideoTab videoType={videoType} videoData={viewVideo} viewPoster={viewPoster} show={isViewModalOpen} setIsViewModalOpen={setIsViewModalOpen} setViewVideo={setViewVideo} setViewPoster={setViewPoster} />)}
      {isDeleteVideoModalOpen && (<DeleteVideoModal deleteVideoData={deleteVideoData} show={isDeleteVideoModalOpen} deleteVideoHandler={deleteVideoHandler} />)}
    </div>
  );
}

export default VideoMediaTab;